import { render, staticRenderFns } from "./ImportDrugDialog.vue?vue&type=template&id=22d020fd&scoped=true&lang=pug&"
import script from "./ImportDrugDialog.vue?vue&type=script&lang=ts&"
export * from "./ImportDrugDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImportDrugDialog.vue?vue&type=style&index=0&id=22d020fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d020fd",
  null
  
)

export default component.exports